import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { Spin } from 'antd';

export const AppRoutes = () => {
  return <RouterProvider router={router} fallbackElement={<Spin fullscreen size="large" />} />;
};
